import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Card from "../common/components/Card";
import TagManager from "../common/components/TagManager";
import { dynamicSort } from "../common/utils/tableUtilities";
import { useCrews } from "../reducers/crewSlice";
import { useUsers } from "../reducers/userSlice";
import PermissionsInput from "./settings/PermissionsInput";
import PropTypes from 'prop-types';

const CrewTags = ({ value, onChange, ...props }) => {
    const crews = useCrews();
    const displayCrews = useMemo(() => {
        const displayCrews = [...crews];
        displayCrews.sort(dynamicSort(['displayid']));
        return displayCrews;
    }, [crews])
    return <TagManager tags={value} values={displayCrews} labelField="displayid" valueField="callsign" onChange={onChange} {...props}></TagManager>
}
CrewTags.propTypes = {
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func
}

const UserTags = ({ value, onChange, ...props }) => {
    const users = useUsers();
    const displayUsers = useMemo(() => {
        const displayUsers = [...users];
        displayUsers.sort(dynamicSort(['username']));
        return displayUsers;
    }, [users])
    return <TagManager tags={value} values={displayUsers} labelField="username" valueField="username" onChange={onChange} {...props}></TagManager>
}
UserTags.propTypes = {
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func
}

export const TaskListPermissions = ({ taskList, disabled, onChange }) => {
    const { t } = useTranslation();
    return <>
    {/* <Row>
        <Col>
                read_code
        </Col>
        <Col>
                write_code
        </Col>
    </Row> */}
    <PermissionsInput values={taskList.perms} title={t('accessPermissions')} disabled={disabled} access={[0,1]} adminPositions={[]} onChange={value => onChange({ perms: value })}></PermissionsInput>
    <Card title={t('crewReadAccess')}>
        <CrewTags value={taskList.read_crews} placeholder={t('crew_other')} disabled={disabled} hideLabel={true} onChange={value => onChange({ read_crews: value })}></CrewTags>
    </Card>
    <Card title={t('crewWriteAccess')}>
        <CrewTags value={taskList.write_crews} placeholder={t('crew_other')} disabled={disabled} hideLabel={true} onChange={value => onChange({ write_crews: value })}></CrewTags>
    </Card>
    <Card title={t('userReadAccess')}>
        <UserTags value={taskList.read_users} placeholder={t('user_other')} disabled={disabled} hideLabel={true} onChange={value => onChange({ read_users: value })}></UserTags>
    </Card>
    <Card title={t('userWriteAccess')}>
        <UserTags value={taskList.write_users} placeholder={t('user_other')} disabled={disabled} hideLabel={true} onChange={value => onChange({ write_users: value })}></UserTags>
    </Card>
    </>
}